
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hqnQO", function(module, exports) {

$parcel$export(module.exports, "MentionComponent", () => $e5eced0f7f5acf84$export$4c646efe5cd4ee34);
/* MentionComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
const $e5eced0f7f5acf84$var$styles = {
    selfMentionWrapper: "_2rkoiti9 _1h6d3acm _16qs1cd0 _syaz15cr",
    mentionWrapper: "_2rkoiti9 _1h6d3acm"
};
const $e5eced0f7f5acf84$export$4c646efe5cd4ee34 = ({ name: name, isUserSelf: isUserSelf })=>{
    return isUserSelf ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        as: "span",
        backgroundColor: "color.background.brand.bold",
        padding: "space.025",
        xcss: $e5eced0f7f5acf84$var$styles.selfMentionWrapper
    }, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        as: "span",
        backgroundColor: "color.background.neutral",
        padding: "space.025",
        testId: "mention-component",
        xcss: $e5eced0f7f5acf84$var$styles.mentionWrapper
    }, name);
};

});


//# sourceMappingURL=MentionComponent.847e5925.js.map
